import { IFeatureFlagRepository } from '../../domain/repositories/IFeatureFlagRepository';

export class GetWorkspaceFlagKeysUseCase {
  constructor(private readonly repository: IFeatureFlagRepository) {}

  async execute(workspaceId: number): Promise<string[]> {
    return this.repository.getEnabledFlagKeysForWorkspace(workspaceId);
  }
}
